import React from "react";
import { useTranslation } from "react-i18next";
import { Signifier, WarningTriangleIcon, WarningTriangleSmallIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

const TooltipInConflict = ({ isInConflict, small, className }) => {
  const { t } = useTranslation();
  return isInConflict ? (
    <Signifier
      type={small ? WarningTriangleSmallIcon : WarningTriangleIcon}
      tooltipText={t("Dependent task dates cannot overlap")}
      className={classNames("warning-icon", className)}
    />
  ) : null;
};

TooltipInConflict.propTypes = {
  isInConflict: PropTypes.bool,
  small: PropTypes.bool,
  className: PropTypes.string,
};
TooltipInConflict.defaultProps = {
  isInConflict: false,
  small: false,
};
TooltipInConflict.displayName = `TooltipInConflict`;

export default TooltipInConflict;
